import {
  NEW_BOOK_ORDER_CREATE_COMPLETED,
  NEW_BOOK_ORDERS_ID_REQUEST,
  NEW_BOOK_ORDERS_ID_REQUEST_COMPLETED,
  NEW_BOOK_ORDERS_ID_REQUEST_FAILED,
  NEW_BOOK_ORDERS_REQUEST,
  NEW_BOOK_ORDERS_REQUEST_COMPLETED,
  NEW_BOOK_ORDERS_REQUEST_FAILED,
} from '../actions/types';

const initialState = {
  newBookOrdersList: {},
  bookOrderIdData: {},
  addNewOrderData: {},
};

export default function newBookRequest(state = initialState, action) {
  switch (action.type) {
    case NEW_BOOK_ORDERS_REQUEST:
      return {
        ...state,
      }
    case NEW_BOOK_ORDERS_REQUEST_COMPLETED:
      return {
        ...state,
        newBookOrdersList: action.data,
      }
    case NEW_BOOK_ORDERS_REQUEST_FAILED:
      return {
        ...state,
        newBookOrdersList: action.data,
      }
    case NEW_BOOK_ORDERS_ID_REQUEST:
      return {
        ...state,
      }
    case NEW_BOOK_ORDERS_ID_REQUEST_COMPLETED:
      return {
        ...state,
        bookOrderIdData: action.data,
      }
    case NEW_BOOK_ORDERS_ID_REQUEST_FAILED:
      return {
        ...state,
        bookOrderIdData: action.data,
      }
    case NEW_BOOK_ORDER_CREATE_COMPLETED:
      return {
        ...state,
        addNewOrderData: action.data,
      }
    default:
      return state;
  }
}
